import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { SpotlightTarget } from '@atlaskit/onboarding';
import Button, { ButtonGroup } from '@atlaskit/button';
import PageHeader from '@atlaskit/page-header';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';

// @source
import { RouteLink } from '../../../components';

const Header = ({ onSpotlightOpen }) => (
  <PageHeader
    actions={(
      <ButtonGroup>
        <SpotlightTarget name="report-promotion">
          <Button
            iconBefore={<QuestionCircleIcon size="small" />}
            appearance="subtle"
            onClick={onSpotlightOpen}
          />
        </SpotlightTarget>
        <SpotlightTarget name="create-report">
          <Button
            appearance="primary"
            component={RouteLink}
            href="/reports/create"
          >
            Create report
          </Button>
        </SpotlightTarget>
      </ButtonGroup>
    )}
    bottomBar={
      <p>You can see your existing reports from the cloud.</p>
    }
  >
    All your reports.
  </PageHeader>
);

Header.propTypes = {
  onSpotlightOpen: PropTypes.func.isRequired,
};

export default Header;
